<template>
  <div class="product">
     <header>
    <Navbar />
    </header>
    <div class="product-header">
      <div class="product_bannnerText">
        <div>智慧医疗</div>
        <div>
          基于新技术研发的新一代医院信息平台系统，体现了“以患者为中心”的管理念，促进
          医院资源在临床医疗和管理运营中的高效配置利用。
        </div>
      </div>
    </div>
    <div class="productCont">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right;">
          <el-breadcrumb-item :to="{ path: 'productCenter' }"
            >产品中心 > 智慧医疗 >
          </el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===1">医院管理信息系统（HIS） </el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===2">电子病历系统</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===3">临床路径系统</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===4">抗菌药物管理系统</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="tabs" style="background-color: #ffffff">
        <div class="tabsCont">
          <el-radio-group v-model="tabPosition" style="margin-bottom: 30px">
          </el-radio-group>

          <div class="tabTitle">
            <div>产品导航</div>
            <div>智慧医疗产品体系</div>
          </div>
          <el-tabs :tab-position="tabPosition" class="a">
            <el-tab-pane>
              <span slot="label" @click="tab(1)">
                <i class="el-icon-caret-right"></i> 医院管理信息系统（HIS）
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">医院管理信息系统（HIS）</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">医院管理信息系统（HIS）简介</div>
                    <div class="outpatientContText">
                      医院管理信息系统，是医院信息化建设的核心与基础。展华医院管理信息系统，是基于新技术研发的新一代医院信息平台系统，融合了现代管理思想，真正体现了“以患者为中心”的管理理念。
                      <br />系统汇聚了互联网时代地方及部队医院的先进管理经验，面向二级、三级医疗卫生机构，全面覆盖医院临床医疗和管理业务，支持HIS与电子病历、医疗辅助业务系统、医院运营管理系统、医保/农合、城镇居民健康档案的无缝集成，帮助医院改善医疗质量、提高诊疗效率、降低医疗成本，促进医院资源在临床医疗和管理运营中的高效配置利用。
                    </div>
                    <div class="outpatientImg">
                      <img :src="medicala" />
                      <div class="line">— HIS系统截图 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="traits">
                      <li>门诊管理</li>
                      <li>住院处管理</li>
                      <li>药品管理</li>
                      <li>收费系统</li>
                      <li>病案管理</li>
                      <li>综合查询系统</li>
                      <li>系统管理</li>
                      <li>医疗保险管理系统</li>
                      <li>医技科室管理系统</li>
                      <li>其他</li>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要特点</div>
                    <li>
                      <span>易操作：</span
                      >用户界面可配置，支持业务控制、报表、界面和特殊业务本地化。
                    </li>
                    <li>
                      <span>易维护：</span
                      >实现程序的自动更新及升级、动态组件加载等。
                    </li>
                    <li>
                      <span>易扩展：</span
                      >核心业务层基于分布式的面向服务的SOA架构建设，具有高扩展性和高集成性，支持多院区、集团化医院管理。
                    </li>
                    <li>
                      <span>多模式：</span
                      >支持PC终端、大屏幕、PDA、手机等多种信息渠道的服务模式对接。
                    </li>
                    <li>
                      <span>可靠性：</span
                      >系统经过长期的性能测试和软件调优，经过多家大型医院的运行验证。
                    </li>
                    <li>
                      <span>安全性：</span
                      >基于工作角色的权限管理，采用单点登录、统一认证、统一授权管理，以及数据访问控制等安全措施；具备自检测、自
                      校验和系统日志等功能。
                    </li>
                  </div>
                </div>
                <div></div>
              </div>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label" @click="tab(2)">
                <i class="el-icon-caret-right"></i> 电子病历系统
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">电子病历系统</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">电子病历系统简介</div>
                    <div class="outpatientContText">
                      电子病历系统是医院信息化建设的重要组成部分。展华全结构化电子病历系统，基于国家卫健委电子病历共享文档规范及互联互通规范要求，严格遵照《电子病历系统功能应用水平分级评价方法及标准》、《电子病历基本架构与数据标准》的相关规定，坚持以病人为中心的设计理念，将电子病历系统与医院管理信息系统无缝连接，给临床医生提供一个完整的病历文书书写和管理系统，实现病历创建、保存、打印、检索、查找、统计、资源共享的一体化，提高工作效率、改进工作质量，更好的为患者服务。
                    </div>
                    <div class="outpatientImg">
                      <img :src="medicalb" />
                      <div class="line">— 电子病历系统截图 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="trait">
                      <li>病历书写</li>
                      <li>数据集成</li>
                      <li>病历审核</li>
                      <li>病历归档</li>
                      <li>其它功能</li>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要特点</div>
                    <li>
                      <span>新交互：</span
                      >全新的用户界面交互设计，节约操作时间。
                    </li>
                    <li>
                      <span>新架构：</span
                      >全新的三层、两层均支持的架构设计，便于维护。
                    </li>
                    <li>
                      <span>更智能：</span
                      >更加智能化的病历书写支持，病程记录连续记录和展现。
                    </li>
                    <li>
                      <span>更安全：</span
                      >全方位的病历数据保护和后台维护功能，病历永不丢失。
                    </li>
                    <li>
                      <span>可靠性：</span
                      >可集成知识库、CDSS和语音操控，历史病历大数据全面服务于临床医师，真正成为医生的临床帮手。
                    </li>
                    <li>
                      <span>安全性：</span
                      >全新的修改痕迹记录和查看方式，全面规避法律风险。
                    </li>
                    <li>
                      <span>更全面：</span
                      >全面支持无纸化归档，二维码、PDF输出、手写签名等，更加全面的专科化病历书写支持，全面体现专科特色。
                    </li>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
            <el-tab-pane
              ><span slot="label" @click="tab(3)"
                ><i class="el-icon-caret-right"></i> 临床路径系统</span
              >
              <div class="outpatient">
                <div class="outpatientTitle">临床路径系统</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">临床路径系统简介</div>
                    <div class="outpatientContText">
                      临床路径是指针对某一疾病建立一套标准化治疗模式与治疗程序。展华临床路径系统通过按病种设计最佳的医疗和护理方案，根据病情合理安排住院时间和费用，不仅可以规范诊疗过程中常规进行的诊疗操作，减少一些不必要、不合理的诊疗行为，还可以规范诊疗完成的时间等内容，增强了诊疗活动的计划性。
                      <br />临床路径所设立的内容可以不断更新，与疾病的最新治疗标准或治疗指南保持一致，同时临床路径也是整个治疗过程的行之有效的记录模式，包含患者病历及病程记录、以日为单位的各种医疗活动记录、治疗护理及执行相关医疗活动后的记录、变异记录表等。
                    </div>
                    <div class="outpatientImg">
                      <img :src="medicalc" />
                      <div class="line">— 展华临床路径基本功能 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要特点</div>
                    <div class="trait">
                      <li>入径选择自由</li>
                      <li>临床事件节点</li>
                      <li>集中填写变异</li>
                      <li>无缝嵌入HIS</li>
                      <li>一键执行医嘱</li>
                      <li>监控与统计分析</li>
                    </div>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
            <el-tab-pane >
              <span slot="label" @click="tab(4)">
                <i class="el-icon-caret-right"></i> 抗菌药物管理系统
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">抗菌药物管理系统</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">抗菌药物管理系统简介</div>
                    <div class="outpatientContText">
                      展华抗菌药物管理系统根据国家有关规定，将医院抗菌药物的使用实行分级管控。医生在开具医嘱时，系统将根据医生职称权限的不同而加以限制，越级使用抗菌药品时需按规定向上级医师填写用药申请单和药房申请单，精确管控抗菌药物的使用。
                      <br />系统能够按月、年统计抗生素使用情况，包括DDD值统计、使用强度统计、金额统计、医生使用抗菌药物情况统计等，并能够进行医嘱处方点评，满足卫健委对于抗菌药物监督管理的要求。
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <li>
                      <span>基础数据维护</span>
                    </li>
                    <li>
                      <span>医护工作站管理</span>
                      <div class="nursing">
                        使用抗菌药物治疗用药时提醒送检，越级使用抗菌药物提示必须填报会诊申请。
                      </div>
                      <div class="nursing">
                        使用特殊级抗菌药物提示必须填报药房申请。
                      </div>

                      <div class="nursing">
                        手术使用抗菌药物预防用药时提示抗菌药物种类。
                      </div>
                      <div class="nursing">
                        越级使用抗菌药物时只能开具临时医嘱，禁止开具抗菌药物长期医嘱。
                      </div>
                      <div class="nursing">
                        手术预防用药提示填写用药时机、用药疗程，开具抗菌药物医嘱要求填写对应的疾病诊断
                      </div>
                    </li>
                    <li>
                      <span>统计分析管理</span>
                      <div class="nursing">
                        抗菌药物处方及医嘱统计，抗菌药物DDD值统计。
                      </div>
                      <div class="nursing">门急诊抗生素使用情况月报表。</div>
                      <div class="nursing">住院患者抗生素使用强度统计。</div>
                    </li>
                    <li>
                      <span>处方点评</span>
                      <div class="nursing">
                        住院抗菌药物医嘱及门急诊抗菌药物处方信息化点评功能。
                      </div>
                      <div class="nursing">
                        住院抗菌药物医嘱及门急诊抗菌药物处方信息化点评功能。
                      </div>
                      <div class="nursing">住院患者抗生素使用强度统计。</div>
                    </li>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <footer>
    <Root/>
    </footer>
  </div>
</template>
<script src="//unpkg.com/vue/dist/vue.js"></script>
<script src="//unpkg.com/element-ui@2.15.7/lib/index.js"></script>
<script>
import Navbar from "../../layout/Navbar.vue";
import Root from "../../layout/root.vue"
import medicalBanner from "../../assets/medicalBanner.png";
import medicala from "../../assets/medicala.png";
import medicalb from "../../assets/medicalb.png";
import medicalc from "../../assets/medicalc.png";
export default {
  name: "medical",
  components: {
    Navbar,Root,
  },
  data() {
   
    return {
       current:1,
      tabPosition: "left",
      medicalBanner: medicalBanner,
      medicala: medicala,
      medicalb: medicalb,
      medicalc: medicalc,
    };
  },
  methods: {
     tab(index){
      this.current=index;

    },
  },
};
</script>
<style scoped>
@import url("//unpkg.com/element-ui@2.15.7/lib/theme-chalk/index.css");
footer{
  height: 520px;
  margin-top: 30px;
}
header{
 background-color: #ffffff;
}
.product {
  background-color: #f5f7fa;
  width: 100%;
  overflow: hidden;

  font-family: PingFangSC-Medium;
}
.product-header {
  position: relative;
  height: 420px;
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/medicalBanner.png") no-repeat;
  background-size: cover;
  background-position:center;
}
/* .productBanner {
  width: 1920px;
  left: 50%;
  margin-left: -960px;
  position: relative;
} */
.product_bannnerText {
  position: absolute;
  left: 7.5%;
  top: 113px;
}
.product_bannnerText :nth-child(1) {
  font-size: 52px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.product_bannnerText :nth-child(2) {
  width: 64%;
  font-size: 18px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 200;
  margin-top: 33px;
}
.productCont {
  width: 85%;
  margin: 0 auto;
}
.crumbs {
  margin-top: 25px;
  margin-bottom: 30px;
}
.crumbs .el-breadcrumb {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 22px;
  font-weight: 400;
}
.tabsCont {
  width: 95%;
  margin: 0 auto;
  position: relative;
}
.tabTitle {
  position: absolute;
  top: 35px;
  z-index: 100;
  width: 20%;
}
.tabTitle :nth-child(1) {
  font-size: 20px;
  margin: 0 auto;
  height: 50px;
  border-bottom: 1px solid #e9eaee;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.tabTitle :nth-child(2) {
  font-size: 16px;
  color: #0f1422;
  letter-spacing: 0;
  margin-top: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}
.outpatient {
  width: 90%;
  margin: 0 auto;
}
.outpatientTitle {
  font-size: 28px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  height: 55px;
  border-bottom: 1px solid #e9eaee;
}
.outpatientConBox {
  width: 100%;
  margin: 0 auto;
}
.outpatientImg {
  width: 100%;
  text-align: center;

  margin: 0 auto;
}
.outpatientImg img {
  margin-top: 50px;
}
.tabs .el-tabs {
  height: 100% !important;
}
.outpatientContTitle {
  font-size: 20px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 50px;
  margin-bottom: 28px;
}
.outpatientContText {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  line-height: 26px;
  font-weight: 400;
  margin-top: 20px;
}
.intro {
  font-size: 20px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 66px;
  margin-bottom: 28px;
}
.a {
  position: relative;
  z-index: 1;
}
.el-icon-caret-right {
  color: #ffffff;
  margin-left: -20px;
}
.outpatientImg .line {
  font-size: 14px;
  color: #767b8d;
  letter-spacing: 0;
  text-align: center;
  line-height: 26px;
  font-weight: 200;
  margin-top: 10px;
}
.outpatientConBox li {
  font-size: 16px;
  margin-bottom: 16px;
  /* margin-top: 30px; */
  color: #3d455f;
  letter-spacing: 0;
  font-weight: 400;
}
.outpatientConBox li span {
  color: #0f1422;
  font-weight: 500;
}
.trait {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
  justify-content: space-between;
}
.traits {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
  justify-content: space-between;
}
.trait:after {
  content: "";
  width: 50%;
}
.traits:after {
  content: "";
  width: 50%;
}
.traits li {
  width: 20%;
}
.nursing {
  text-indent: 1em;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 400;
  margin-top: 16px;
}
.nursing span {
  color: #29324c;
}
.tabsCont >>> .el-tabs__header {
  /* width: 20% !important; */
  /* background-color: #ffffff; */
  padding-top: 120px;
}
.tabsCont >>> .el-tabs__content {
  border-left: #f5f7fa 8px solid;

  background-color: #ffffff;
}
.tabsCont >>> .el-radio-group {
  margin: 0;
}
.tabsCont >>> .el-tabs__item {
  text-align: left;
  font-size: 16px;
  color: #0f1422;
  letter-spacing: 0;
  width: 95%;
  font-weight: 400;
}
.tabsCont >>> .el-tabs__item.is-active {
  text-align: left;
  font-size: 16px;
  width: 95%;
  background-color: #e52f22;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
.tabsCont >>> .el-tabs__item {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/views/medical/index.vue